export const SHOP_ORDERS_API_PATH = 'shop/orders';
export const SHOP_ORDERS_TYPE = 'shop_order';
export const RESET_SHOP_ORDERS_API_PATH = 'reset';
//# sourceMappingURL=helpers.js.map